import { all, takeLatest, call } from 'redux-saga/effects'
import fetchData from '../helpers/fetchData'
import actions from './actions'
import { getQuestions, getQuestionTypes } from '../../services/survey'

function* fetchQuestions({ payload }) {
  const service = () => getQuestions(payload)
  yield call(fetchData, actions.questionsName, service)
}

function* fetchQuestionTypes({ payload }) {
  const service = () => getQuestionTypes(payload)
  yield call(fetchData, actions.questionTypesName, service)
}

export default function* rootSaga() {
  yield all([
    takeLatest(actions.requestQuestions, fetchQuestions),
    takeLatest(actions.requestQuestionTypes, fetchQuestionTypes),
  ])
}
